import { Button, Card } from "antd";
import React, { FC, useEffect, useState } from "react";
import bgImage from "src/assets/images/Impirica_Pattern_BLUE_1920x1080.png";
import impLogo from "src/assets/images/Impirica_Logo_RGB-LG-Blue.png";
import { LogIn } from "lucide-react";
import { Icon } from "src/components/icons/Icon";
import { FeatureGate } from "./FeatureGate";

type LoginPageProps = {};

export const LoginPage: FC<LoginPageProps> = () => {
	const [featureGate, setFeatureGate] = useState<FeatureGate>({
		use_prod_logins: false,
	});

	//#region Styles
	const styles = {
		background: {
			backgroundImage: `url(${bgImage})`,
			backgroundPosition: "right top",
			height: "100vh",
			width: "100vw",
			margin: 0,
			padding: "100px 0 0 0",
		},
		logo: {
			height: 96,
			marginLeft: -16,
		},
		card: {
			width: 500,
			borderRadius: 5,
			marginLeft: "auto",
			marginRight: "auto",
		},
		button: {
			borderRadius: 5,
			minWidth: 150,
			height: 50,
		},

		buttonText: {
			fontSize: "1rem",
		},
		welcomeText: {
			fontSize: "1.5rem",
		},
		buttonContainer: {
			flex: 1,
			alignContent: "space-between",
		},
	};
	//#endregion

	const getFeatureGate = async () => {
		try {
			const resp = await fetch("/feature-gate", {
				headers: new Headers({
					"X-CSRF": "1",
					"content-type": "application/json",
				}),
			});
			if (resp.ok) {
				const features: FeatureGate = await resp.json();
				setFeatureGate(features);
			}
		} catch (e) {
			console.error("unable to retrieve client configuration", e);
		}
	};

	useEffect(() => {
		getFeatureGate();
	}, []);

	const CardTitle = () => (
		<div>
			<img src={impLogo} style={styles.logo} alt="Impirica Logo" />
		</div>
	);

	return (
		<div style={styles.background}>
			<Card title={<CardTitle />} bordered={false} style={styles.card}>
				<p style={styles.welcomeText}>
					Welcome to the Impirica Platform! Please sign in to continue.
				</p>
				<br />
				{featureGate.use_prod_logins ? (
					<div style={styles.buttonContainer}>
						<Button
							className="btn-secondary"
							onClick={() =>
								(window.location.href = "https://ca.impirica.tech/bff/login")
							}
							style={styles.button}
							size="large"
						>
							<span style={styles.buttonText}>
								<Icon icon={LogIn} /> Canada Login
							</span>
						</Button>
						<div style={{ float: "right" }}>
							<Button
								className="btn-secondary"
								onClick={() =>
									(window.location.href = "https://us.impirica.tech/bff/login")
								}
								style={styles.button}
								size="large"
							>
								<span style={styles.buttonText}>
									<Icon icon={LogIn} />
									US Login
								</span>
							</Button>
						</div>
					</div>
				) : (
					<Button
						className="btn-secondary"
						onClick={() => (window.location.href = "/bff/login")}
						style={styles.button}
						size="large"
					>
						<span style={styles.buttonText}>
							<Icon icon={LogIn} /> Login
						</span>
					</Button>
				)}
			</Card>
		</div>
	);
};
